import React from 'react';
import { Card } from 'react-bootstrap';

import TabThiTruong from './layout/phan-tich-thi-truong/thi-truong';
import TabToChuc from './layout/phan-tich-thi-truong/to-chuc';
import TabNganh from './layout/phan-tich-thi-truong/nganh';
import TabDongTien from './layout/phan-tich-thi-truong/dong-tien';
import { memo } from 'react';

import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import * as _ from 'lodash';

function TabAnalysisMarket(props) {
  const [tabActive, setTabActive] = React.useState('thi-truong');
  const [marketActive, setMarketActive] = React.useState('HOSE');
  const [nganhActive, setNganhActive] = React.useState('M');

  const { t, theme } = props;

  // console.log(DMNGANH)

  return (
    <Card className="w-100" style={{ height: 'calc(100vh - 95px)' }}>
      <Card.Header className="d-flex py-0">
        <div className="d-flex py-0 pr-2 tabs-cash mr-auto">
          <a
            className={
              'fz-14 content-read ' +
              (tabActive === 'thi-truong' ? 'active' : '')
            }
            onClick={() => setTabActive('thi-truong')}
          >
            {t('algo.pttt.txt-market')}
          </a>
          <a
            className={
              'fz-14 content-read ' + (tabActive === 'to-chuc' ? 'active' : '')
            }
            onClick={() => setTabActive('to-chuc')}
          >
            {t('algo.pttt.txt-institutions')}
          </a>
          <a
            className={
              'fz-14 content-read ' + (tabActive === 'nganh' ? 'active' : '')
            }
            onClick={() => setTabActive('nganh')}
          >
            {t('algo.pttt.txt-industry')}
          </a>
          <a
            className={
              'fz-14 content-read ' +
              (tabActive === 'dong-tien' ? 'active' : '')
            }
            onClick={() => setTabActive('dong-tien')}
          >
            {t('algo.pttt.txt-money-flow')}
          </a>
        </div>
        <div className="d-flex py-0 pr-2 tabs-cash">
          <a
            className={
              'fz-14 content-read ' + (marketActive === 'HOSE' ? 'active' : '')
            }
            onClick={() => setMarketActive('HOSE')}
          >
            HOSE
          </a>
          <a
            className={
              'fz-14 content-read ' + (marketActive === 'HNX' ? 'active' : '')
            }
            onClick={() => setMarketActive('HNX')}
          >
            HNX
          </a>
          <a
            className={
              'fz-14 content-read ' + (marketActive === 'UPCOM' ? 'active' : '')
            }
            onClick={() => setMarketActive('UPCOM')}
          >
            UPCOM
          </a>
          <a
            className={
              'fz-14 content-read ' + (marketActive === 'VN30' ? 'active' : '')
            }
            onClick={() => setMarketActive('VN30')}
          >
            VN30
          </a>
          <div
            className="cart-action d-flex align-items-center justify-content-center padding fz-14"
            style={{
              // border: '1px solid #2E2D3D',
              // borderWidth: '0 1px',
              padding: '3px 3px 3px 15px',
            }}
          >
            <select
              className="form-control fz-13"
              style={{ marginLeft: '5px' }}
              value={nganhActive}
              onChange={(e) => setNganhActive(e.target.value)}
            >
              <option value="M">{t('algo.pttt.txt-matching')}</option>
              <option value="P">
                {t('algo.pttt.txt-matching-putthrough')}
              </option>
            </select>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="h-100" style={{ padding: '15px' }}>
        {tabActive === 'thi-truong' && (
          <TabThiTruong
            typeOrder={nganhActive}
            marketActive={marketActive}
            t={t}
            theme={theme}
          />
        )}
        {tabActive === 'to-chuc' && (
          <TabToChuc
            typeOrder={nganhActive}
            marketActive={marketActive}
            t={t}
            theme={theme}
          />
        )}
        {tabActive === 'nganh' && (
          <TabNganh
            typeOrder={nganhActive}
            marketActive={marketActive}
            t={t}
            theme={theme}
          />
        )}
        {tabActive === 'dong-tien' && (
          <TabDongTien
            typeOrder={nganhActive}
            marketActive={marketActive}
            t={t}
            theme={theme}
          />
        )}
      </Card.Body>
    </Card>
  );
}

const mapStateToProps = (state) => {
  // console.log(state.client)
  return {
    theme: state.client?.setting?.theme === 'light' ? 'light' : 'dark',
  };
};

export default connect(mapStateToProps)(
  translate('translations')(memo(TabAnalysisMarket))
);
